module.exports = __webpack_public_path__ + "img/xxpxxx.76c7051d.png";